import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import { export3DModel } from '../network';

type ExportParams = {
  file_type: 'ply' | 'stl';
  model_type: 'bent' | 'standing';
};

export const useExport3DModel = () => {
  const [params] = useSearchParams();
  const scanId = params.get('scanId');
  const [isExporting, setIsExporting] = useState(false);

  const exportModel = async (params: ExportParams) => {
    if (!scanId) {
      enqueueSnackbar('Scan ID is missing. Cannot export 3D model.', {
        variant: 'error',
      });
      return;
    }

    setIsExporting(true);
    try {
      await export3DModel({
        id: scanId,
        model_type: params.model_type,
        file_type: params.file_type,
      });
    } catch (error) {
      enqueueSnackbar('Failed to export 3D model.', {
        variant: 'error',
      });
    } finally {
      setIsExporting(false);
    }
  };

  return { exportModel, isExporting };
};
